module.exports = __webpack_public_path__ + "static/media/warning-icon-active.fb7a7534.svg";